export class MessageTypes {
  static request = 'request';
  static newChatAcknowledgement = 'newChatAcknowledgement';
  static acknowledgement = 'acknowledgement';
  static error = 'error';
  static notification = 'notification';
}
